import { memo } from "react";
import Svg, { Circle, Path, Rect, type SvgProps } from "react-native-svg";

const SvgWallet = (props: SvgProps) => (
  <Svg fill="none" height={31} width={32} {...props}>
    <Rect
      fill="#fff"
      height={19.109}
      rx={5}
      stroke="#000054"
      strokeWidth={2}
      width={29.834}
      x={1.077}
      y={10.508}
    />
    <Circle cx={15.993} cy={10.644} fill="#F49090" r={9.081} stroke="#000054" strokeWidth={2} />
    <Path
      d="M20.991 5.254a.92.92 0 0 0 .26-.646.93.93 0 0 0-.257-.643.89.89 0 0 0-.996-.192.9.9 0 0 0-.476.486.9.9 0 0 0-.07.355q0 .19.068.355a.885.885 0 0 0 .829.553.88.88 0 0 0 .642-.268m-.625-.51h-.22v.367h-.2V4.052h.47q.183 0 .294.09t.11.248a.32.32 0 0 1-.067.211.35.35 0 0 1-.176.11l.283.4h-.24z"
      fill="#000054"
    />
    <Path
      d="M20.56 4.277a.24.24 0 0 0-.152-.043h-.261v.335h.26a.24.24 0 0 0 .153-.045.15.15 0 0 0 .056-.123.15.15 0 0 0-.056-.124M17.51 8.505q.013-.104.034-.242.02-.139.008-.276a1 1 0 0 0-.083-.309.63.63 0 0 0-.226-.258 1.1 1.1 0 0 0-.419-.157 2.3 2.3 0 0 0-.659-.002q-.418.049-.664.166a1.2 1.2 0 0 0-.387.27.8.8 0 0 0-.188.326 1.6 1.6 0 0 0-.06.334.3.3 0 0 0-.005.113q.03.324.41.467t1.148.155q.678.014 1.235.114.557.098.963.332.406.232.652.63.247.396.304 1.007.015.157.015.33t-.008.36a4 4 0 0 1-.313 1.315 3.9 3.9 0 0 1-.758 1.15 4.2 4.2 0 0 1-1.177.863 4.6 4.6 0 0 1-1.561.45q-.996.116-1.646-.023-.653-.14-1.062-.432a2 2 0 0 1-.623-.704 3.8 3.8 0 0 1-.318-.846l2.146-1.384a1.5 1.5 0 0 0-.012.404q.018.194.098.386t.253.335q.174.144.47.212.295.069.735.017.71-.083 1.075-.407a1.08 1.08 0 0 0 .389-.775.4.4 0 0 1 0-.088.4.4 0 0 0 0-.09q-.024-.25-.19-.37-.17-.12-.5-.18a8 8 0 0 0-.833-.094q-.503-.034-1.184-.104a3.7 3.7 0 0 1-.71-.15 1.9 1.9 0 0 1-.616-.33 1.8 1.8 0 0 1-.457-.564 2.2 2.2 0 0 1-.232-.852 3.856 3.856 0 0 1-.005-.588 6 6 0 0 1 .104-.733 4 4 0 0 1 .244-.786q.166-.394.435-.767.27-.373.678-.678.41-.303.969-.525a5.3 5.3 0 0 1 1.303-.307q.84-.098 1.452.013.612.11 1.02.385.41.276.633.679.224.404.287.902z"
      fill="#000054"
    />
    <Rect fill="#000054" height={1.714} rx={0.857} width={20.565} x={6.088} y={17.676} />
    <Path d="M6.088 19.442h20.565v2.521H6.088z" fill="#fff" />
  </Svg>
);
const Memo = memo(SvgWallet);
export default Memo;
